<template lang="pug">
div
  .faq
    .f-about.max-container
      .seo(v-if="metaData.length > 0")
        //- h4 About Us
        //- p
        //-   | Welcome to EpicWin, home of a Magical Gaming Experience that will forever change how you Win!
        //-   br
        //-   | We welcome ONE and ALL into our realm. Come and discover for yourself the MAGIC of what we have to offer.
        #readmore.collapse
          div(v-if="metaData[0].en_body" v-html="metaData[0].en_body")
          p.text-center(v-if="currentPath == '/'")
            iframe#gMap(src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.071293625022!2d101.5847189!3d3.0756352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc4d0068778ce9%3A0x783382852975494f!2sEpicWin!5e0!3m2!1sen!2smy!4v1722308875027!5m2!1sen!2smy' width='450' height='450' allowfullscreen='allowfullscreen' referrerpolicy='no-referrer-when-downgrade' style='border: 0px;')
        button.btn-read-more.collapsed(v-if="metaData.length > 0" type='button' data-bs-toggle='collapse' href='#readmore' aria-expanded='false' aria-controls='readmore')
      .seo.text-center(v-else :class="{'border-top-0 p-0': currentPath !== '/'}")
        iframe#gMap(v-if="currentPath == '/'" src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.071293625022!2d101.5847189!3d3.0756352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc4d0068778ce9%3A0x783382852975494f!2sEpicWin!5e0!3m2!1sen!2smy!4v1722308875027!5m2!1sen!2smy' width='450' height='450' allowfullscreen='allowfullscreen' referrerpolicy='no-referrer-when-downgrade' style='border: 0px;')
  .footer-sec
    .max-container
      .menu-footer
        div
          ul
            p Games
            li
              router-link(to="/slot") {{$t('ui.slots')}}
            li
              router-link(to="/live") {{$t('ui.live')}}
            li 
              router-link(to="/fish") {{$t('ui.fish')}}
            li
              router-link(to="/minigame") {{$t('ui.minigame')}}
            li
              router-link(to="/freeplay") {{$t('ui.demoplay')}}
        div
          ul
            p Information
            li
              router-link(to="/aboutUs") {{$t('ui.aboutus')}}
            li
              router-link(to="/reviews") {{$t('ui.leaderboard')}}
            li
              router-link(to="/news") {{$t('ui.news')}}
            //- li
              router-link(to="contactUs") Contact Us
            li
              router-link(to="/responsible-gaming") {{$t('ui.responsible')}}
            li
              router-link(to="/faq") {{$t('ui.faq')}}
            li
              router-link(to="/tnc") {{$t('ui.tnc')}}
            li
              router-link(to="/contactUs") {{$t('ui.contactus')}}
        div
          ul
            p Certification
            li
              img(src='/images/footer/cert/cert.png')
          ul
            p {{$t('ui.responsible')}}
            li
              img(src='/images/footer/cert/res.png')
      .partner-footer
        p Partners
        img(src='/images/footer/partner/disney.png')
        img(src='/images/footer/partner/warner_bros.png')
        img(src='/images/footer/partner/reward1.svg')
        img(src='/images/footer/partner/reward2.svg')
        img(src='/images/footer/partner/reward3.svg')
        img(src='/images/footer/partner/reward4.svg')
        img(src='/images/footer/partner/reward5.svg')
      .provider-logo-wrapper
        p Providers
        img(src='/images/provider/epicwin.png')
        img(src='/images/provider/megah5.png')
        img(src='/images/provider/pragmatic.png')
        img(src='/images/provider/joker.png')
        img(src='/images/provider/jili.png')
        img(src='/images/provider/jdb.png')
        img(src='/images/provider/live22.png')
      .payment-footer
        p Payment Methods
        img(src='/images/payment/fpx.png')
        img(src='/images/payment/dn.png')
        img(src='/images/payment/tng.png')
        img(src='/images/payment/grab.png')
        img(src='/images/payment/boost.png')
        img(src='/images/payment/celcom.png')
        img(src='/images/payment/digi.png')
        img(src='/images/payment/maxis.png')
        img(src='/images/payment/umobile.png')
      .social-footer
        p Follow Us
        contactUs
</template>
<script>
import config from "@/config"
import contactUs from '@/views/default/_contactUs.vue'
export default {
  components:{
    contactUs
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      showArticle : true,
      currentPath: "",
      globeArray: [
        "http://epicwin.app/",
        "http://www.epicwin.app/",
        "https://epicwin.app/",
        "https://www.epicwin.app/",
      ],
      showFooter:false,
      metaData:[]
    }
  },
  metaInfo(){
    if(this.metaData.length> 0){
      return{
        title: this.metaData[0].meta_title || 'EpicWin Malaysia',
        meta:[
          { name: 'description',content: this.metaData[0].meta_desc },
          { name: "keywords", content: this.metaData[0].meta_keywords },
          { name: "author", content: this.metaData[0].meta_author },
          { name: "publisher", content: this.metaData[0].meta_publisher },

          { property: 'og:title', content: this.metaData[0].meta_title },
          { property: 'og:description', content: this.metaData[0].meta_desc },
          
        ],
      }
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    inboxList(){
      return this.$store.state.user.inbox
    },
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
      this.getSeo()
      // if(this.currentPath === '/'){
      //   this.getSeo('home')
      // }
      // if(to.path === '/' || to.path === '/aboutUs' || to.path === '/promotions'){
      //   this.showArticle = true
      // }else{
      //   this.showArticle = false
      // }
    }
  },
  mounted(){
    // this.checkDomain();
    this.currentPath = this.$router.currentRoute.fullPath
    // if(this.currentPath === '/'){
    //   this.getSeo('home')
    // }
    if(this.$router.currentRoute.fullPath === '/' || this.$router.currentRoute.fullPath === '/aboutUs' || this.$router.currentRoute.fullPath === '/promotions'){
      this.showArticle = true
    }else{
      this.showArticle = false
    }
    this.getSeo()
  },
  beforeDestroy: function() {
    // clearInterval(this.refreshInbox)
    // clearInterval(this.continueRefreshInbox)
  },
  methods:{
    getSeo(){
      this.metaData = []
      var temp = window.location.pathname.split("/")
      var domain_name = window.location.hostname
      // var domain_name = "www.member.epwuatmy788.com"
      // Remove 'www.' if it exists in the hostname
      domain_name = domain_name.startsWith("www.") ? domain_name.slice(4) : domain_name;
      if(this.currentPath === '/'){
        var page_name = "home"
      }else{
        var page_name = temp[temp.length-1]
      }
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
              $('link[rel="canonical"]').attr('href', this.metaData[0].meta_canonical);
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    checkDomain() {
      var site =
        window.location.protocol + "//" + window.location.hostname + "/";
      if (this.globeArray.includes(site)) {
        this.showFooter = true
      }
    },
    // getSeo(page){
		// 	let page_name = page
    //   let domain_name = window.location.hostname
    //   // let domain_name = "member.epwuatmy788.com"
		// 	this.$store
		// 		.dispatch("user/getSeo", {page_name, domain_name})
		// 		.then(response => {
		// 			this.loading = false;
		// 			this.feedback.success = response.success
		// 			if (this.feedback.success == true) {
		// 				if(response.data.length > 0){
		// 					// this.$store.dispatch("user/seoInfo", response.data[0])
    //           this.metaData = response.data
		// 				}
		// 			} else {
		// 				if((typeof response.status) != 'object'){
		// 					this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
		// 				}       
		// 			}
		// 		})
		// 		.catch(response => {
		// 			this.loading = false;
		// 			var vm = this;
		// 			if((typeof response.status) != 'object'){
		// 				this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
		// 			}
		// 		});
		// },
    goToEpic(){
      window.open("https://epicwin.info/activity/")
    },
    openChat(){
      LiveChatWidget.call("maximize");
    },
    // setNewLoop(){
    //   this.continueRefreshInbox = setInterval( () => {
    //     this.getInboxList()
    //   }, 30000)
    // },
    // getInboxList(){
    //   if(this.sessionToken) {
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     this.loading = true
    //     this.$store
    //       .dispatch("user/getInbox", { account_id, auth_token })
    //       .then(response => {
    //         this.loading = false
    //         this.feedback.success = response.success
    //         this.feedback.status = response.status
    //         if (this.feedback.success == true) {

    //         } else {
    //           this.feedback.status = this.$t("error." + response.status)
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         this.loading = false
    //         this.feedback.success = false
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //         this.feedback.status = this.$t("error." + response.status)
    //         $('body').removeClass('modal-open');
    //         $('.modal-backdrop').remove();
    //       });
    //   }
    // },
  }
}
</script>
<style lang="scss" scoped>
.no-wrap{
  white-space: nowrap;
  color:#FFC000
}
table, td {
  border: 1px solid white;
}
td{
  padding: 5px 10px
}
#gMap{
  @media(max-width: 720px){
    width: 100% !important;
  }
}
</style>
